var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsimDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 278,
    viewBox: "0 0 327 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5596 52.6448C113.685 34.6183 144.291 27.5937 173.862 33.2953L221.31 42.4435C275.236 52.8406 311.942 103.165 305.369 157.689C299.07 209.951 254.919 249.392 202.28 249.783L123.787 250.365C94.1219 250.585 65.9196 237.5 46.9318 214.708C10.5927 171.087 18.2703 105.911 63.7508 71.9288L89.5596 52.6448Z",
    fill: "#191C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.95 52.6652C174.365 45.2471 212.021 57.2551 237.42 84.3847L250.653 98.5198C280.522 130.425 281.609 179.692 253.176 212.883C230.759 239.052 194.852 249.256 162.024 238.787L110.044 222.211C77.2149 211.743 53.8442 182.636 50.7144 148.321C46.7447 104.797 76.1517 65.2541 118.977 56.5302L137.95 52.6652Z",
    fill: "#230800"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8592_55666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.341 126.896C204.67 93.1853 259.941 135.843 233.658 176.143C228.665 183.799 221.213 189.526 212.529 192.381L123.457 221.661C108.414 226.606 91.8779 223.24 79.9657 212.807C46.0393 183.093 72.3492 127.528 116.834 134.942L135.267 138.014C148.025 140.141 161.112 135.958 170.341 126.896Z",
    fill: "#3F3D56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8592_55666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.723 207.543C281.723 207.797 281.52 208.001 281.266 208.001H80.4575C80.2038 208.001 80 207.797 80 207.543C80 207.29 80.2038 207.086 80.4575 207.086H281.266C281.52 207.086 281.723 207.29 281.723 207.543Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.389 185.266L221.696 194.878L214.775 196.8L213.237 186.419L219.389 185.266Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.539 154.125L223.234 160.277L218.62 167.582L225.156 171.811L236.306 159.123L230.539 154.125Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.232 90.6875L234.383 111.449C234.383 111.449 261.681 135.287 258.99 140.285C256.298 145.283 238.228 159.124 238.228 159.124C238.228 159.124 239.569 163.55 235.631 161.722C231.692 159.893 227.463 154.895 227.463 154.895C227.463 154.895 227.463 151.05 229.385 151.819C231.307 152.588 240.15 142.207 240.15 142.207L220.927 124.521V183.66C220.927 183.66 225.54 187.694 220.927 188.019C216.313 188.345 212.084 189.114 212.084 189.114C212.084 189.114 206.701 187.191 208.623 185.269L202.856 153.742L198.627 115.294L201.703 95.3012L228.232 90.6875Z",
    fill: "#1A1924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.928 193.725C215.928 193.725 216.313 192.188 217.851 192.188H222.548C222.548 192.188 224.002 198.724 223.618 198.724C223.233 198.724 229.77 207.182 222.849 207.567C215.928 207.951 214.006 207.182 214.006 207.182L213.237 204.147C213.237 204.147 212.084 202.184 212.468 200.646C212.853 199.108 215.928 193.725 215.928 193.725Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.541 168.732C225.541 168.732 229.957 168.662 228.902 169.85C227.848 171.039 225.925 172.961 225.925 172.961C225.925 172.961 221.352 182.188 219.217 180.458C217.082 178.728 213.622 159.504 214.775 157.197C215.929 154.891 217.467 154.891 217.467 154.891L224.56 159.157C224.56 159.157 220.158 169.885 225.541 168.732Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.775 58.0052L216.313 48.3933L205.932 44.1641L204.395 58.7742L214.775 58.0052Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M214.775 58.0052L216.313 48.3933L205.932 44.1641L204.395 58.7742L214.775 58.0052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.818 56.6618L216.121 53.5859L229.193 57.8152C229.193 57.8152 234.96 73.9632 233.038 79.7304C231.115 85.4975 231.115 96.7624 231.115 96.7624C231.115 96.7624 230.923 91.8414 219.773 95.3017C208.624 98.7619 200.549 98.3775 200.549 98.3775L200.165 84.5363L195.335 72.242C193.271 66.987 195.496 61.0208 200.497 58.401L203.818 56.6618Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.295 101.952C262.031 104.032 262.365 106.613 261.042 107.718C259.718 108.823 257.238 108.032 255.501 105.951C254.796 105.129 254.298 104.151 254.049 103.097L246.805 94.1918L250.334 91.3359L257.747 100.012C258.739 100.446 259.613 101.111 260.295 101.952Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.635 57.9375L226.113 67.9248L238.454 87.6787L251.052 100.34L255.135 96.9524L242.43 81.144L232.799 60.7754L228.635 57.9375Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.012 48.2953C266.8 47.6458 273.258 38.1068 272.436 26.9892C271.615 15.8717 263.825 7.38556 255.036 8.03501C246.248 8.68446 239.79 18.2235 240.612 29.3411C241.433 40.4586 249.223 48.9447 258.012 48.2953Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.677 48.2969H256.908V124.976H257.677V48.2969Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.869 46.6758L257.961 49.3929L259.189 51.9082L254.066 51.6469L256.22 49.4809L255.976 47.0121L257.869 46.6758Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.151 51.4806C217.998 51.4806 222.737 46.7411 222.737 40.8946C222.737 35.0481 217.998 30.3086 212.151 30.3086C206.305 30.3086 201.565 35.0481 201.565 40.8946C201.565 46.7411 206.305 51.4806 212.151 51.4806Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.307 26.663C211.613 26.8418 212.023 26.5712 212.122 26.2304C212.22 25.8896 212.105 25.5277 211.992 25.1917L211.421 23.5C211.016 22.3002 210.586 21.0584 209.708 20.1452C208.384 18.7669 206.28 18.4162 204.386 18.6702C201.953 18.9965 199.552 20.3138 198.421 22.4922C197.29 24.6705 197.772 27.7101 199.816 29.0692C196.903 32.4081 195.887 36.1291 196.047 40.5573C196.208 44.9854 201.033 49.0607 204.18 52.1802C204.883 51.7542 205.522 49.7577 205.135 49.0324C204.749 48.3072 205.303 47.4669 204.824 46.7989C204.345 46.1308 203.945 47.1946 204.429 46.5303C204.734 46.1111 203.543 45.1469 203.996 44.896C206.192 43.6825 206.922 40.9463 208.3 38.851C209.963 36.3236 212.81 34.6121 215.822 34.3281C217.481 34.1717 219.233 34.455 220.594 35.4183C221.954 36.3816 222.834 38.1029 222.519 39.7394C223.335 38.9101 223.742 37.6947 223.589 36.5409C223.435 35.387 222.725 34.3201 221.72 33.7329C222.331 31.712 221.808 29.3874 220.39 27.8236C218.971 26.2598 213.217 26.5261 211.147 26.9377",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.985 34.3906C208.242 34.6867 206.262 37.0624 204.59 39.2564C203.626 40.521 202.616 41.9175 202.641 43.5072C202.665 45.1146 203.74 46.4932 204.253 48.0164C205.093 50.5062 204.275 53.4685 202.276 55.1745C204.251 55.5492 206.386 54.0687 206.726 52.0879C207.123 49.7821 205.375 47.5567 205.582 45.2262C205.765 43.173 207.383 41.5928 208.758 40.0576C210.134 38.5224 211.426 36.4852 210.793 34.5235",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.889 98.1797H121.815C112.847 98.1797 105.578 105.449 105.578 114.416V191.093C105.578 200.061 112.847 207.33 121.815 207.33H200.889C209.857 207.33 217.126 200.061 217.126 191.093V114.416C217.126 105.449 209.857 98.1797 200.889 98.1797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.889 207.716H121.814C112.65 207.716 105.193 200.26 105.193 191.095V114.418C105.193 105.253 112.65 97.7969 121.814 97.7969H200.889C210.054 97.7969 217.51 105.253 217.51 114.418V191.095C217.51 200.26 210.054 207.716 200.889 207.716ZM121.814 98.5658C113.073 98.5658 105.962 105.677 105.962 114.418V191.095C105.962 199.836 113.073 206.947 121.814 206.947H200.889C209.63 206.947 216.741 199.836 216.741 191.095V114.418C216.741 105.677 209.63 98.5658 200.889 98.5658H121.814Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.546 105.726C193.559 105.726 194.38 104.905 194.38 103.892C194.38 102.88 193.559 102.059 192.546 102.059C191.534 102.059 190.713 102.88 190.713 103.892C190.713 104.905 191.534 105.726 192.546 105.726Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.588 105.726C198.601 105.726 199.422 104.905 199.422 103.892C199.422 102.88 198.601 102.059 197.588 102.059C196.576 102.059 195.755 102.88 195.755 103.892C195.755 104.905 196.576 105.726 197.588 105.726Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.63 105.726C203.643 105.726 204.464 104.905 204.464 103.892C204.464 102.88 203.643 102.059 202.63 102.059C201.618 102.059 200.797 102.88 200.797 103.892C200.797 104.905 201.618 105.726 202.63 105.726Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.223 180.488C118.653 180.488 118.189 180.952 118.189 181.521C118.189 181.799 118.297 182.056 118.491 182.246C118.688 182.447 118.945 182.554 119.223 182.554H201.923C202.492 182.554 202.956 182.091 202.956 181.521C202.956 181.244 202.849 180.987 202.654 180.797C202.458 180.596 202.2 180.488 201.923 180.488H119.223Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.443 180.145V182.899H119.223C118.844 182.899 118.5 182.748 118.252 182.493C117.997 182.245 117.846 181.901 117.846 181.522C117.846 180.764 118.466 180.145 119.223 180.145L163.443 180.145Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.201 174.978H186.427C184.908 174.978 183.672 173.743 183.672 172.224C183.672 170.704 184.908 169.469 186.427 169.469H200.201C201.72 169.469 202.956 170.704 202.956 172.224C202.956 173.743 201.72 174.978 200.201 174.978Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.454 176.947L138.825 144.594L138.088 144.813L147.683 177.052",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.787 103.315C157.575 102.665 164.033 93.1263 163.212 82.0087C162.39 70.8912 154.6 62.4051 145.812 63.0545C137.024 63.704 130.565 73.243 131.387 84.3606C132.209 95.4782 139.999 103.964 148.787 103.315Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.453 103.316H147.684V179.996H148.453V103.316Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.258 143.656L140.121 146.234L142.015 148.295L137.03 149.505L138.477 146.815L137.539 144.518L139.258 143.656Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.645 101.695L148.737 104.412L149.965 106.928L144.842 106.666L146.995 104.5L146.752 102.032L148.645 101.695Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.517 144.333C147.747 141.184 151.191 130.191 147.208 119.779C143.225 109.367 133.324 103.479 125.093 106.627C116.863 109.776 113.419 120.769 117.402 131.181C121.385 141.593 131.286 147.481 139.517 144.333Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38 94.247C211.974 95.03 213.672 97.003 213.173 98.6534C212.675 100.304 210.168 101.007 207.574 100.223C206.533 99.9242 205.579 99.3806 204.792 98.6375L193.845 95.181L195.223 90.8555L206.184 94.0276C207.252 93.8445 208.348 93.9197 209.38 94.247Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.361 65.8882L201.895 57.4297L201.511 73.5777L190.745 87.4189L202.28 92.0326L201.895 98.6201C201.895 98.6201 187.285 95.1084 184.978 94.7239C182.671 94.3395 180.749 88.9568 180.749 88.9568L190.361 65.8882Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8592_55666",
    x: 44.5215,
    y: 68.6992,
    width: 276.001,
    height: 209.203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 30,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.411765 0 0 0 0 0.172549 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8592_55666"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8592_55666",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8592_55666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201.723,
    height: 200,
    fill: "white",
    transform: "translate(80 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsimDark);
export default __webpack_public_path__ + "static/media/EsimDark.09d042d40156f5055ab3887017792c01.svg";
export { ForwardRef as ReactComponent };